import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem} from "./Components";

import gro_flo_haz_lev from "../img/sswpIcons/GroundFloor/gro_flo_haz_lev.png";
import gro_flo_fir_gro from "../img/sswpIcons/GroundFloor/gro_flo_fir_gro.png";
import gro_flo_hou from "../img/sswpIcons/GroundFloor/gro_flo_hou.png";
import gro_flo_acc_egr from "../img/sswpIcons/GroundFloor/gro_flo_acc_egr.png";
import gro_flo_reb from "../img/sswpIcons/GroundFloor/gro_flo_reb.png";
import gro_flo_sca from "../img/sswpIcons/GroundFloor/gro_flo_sca.png";
import gro_flo_tre from "../img/sswpIcons/GroundFloor/gro_flo_tre.png";
import gro_flo_wor_rou from "../img/sswpIcons/GroundFloor/gro_flo_wor_rou.png";
import gro_flo_sit_spe_met from "../img/sswpIcons/GroundFloor/gro_flo_sit_spe_met.png";
const json = {
    icon: gro_flo_haz_lev,
    name: "Ground Floor",
    text: "",
    icons: {
        gro_flo_hou: {
            name: "Housekeeping",
            icon: gro_flo_hou,
            text: (
                <ul>
                    <ListItem text="Accessways must be kept clear of tools, plant, equipment, materials, rubbish or detritus materials/dirt & muck. Bins need to be provided and used." />
                    <ListItem text="Slip, trip and fall hazards need to be removed." />
                    <ListItem text="Protruding nails, screws or other sharp object need to be removed." />
                    <ListItem text="The storage of tools and materials needs to be organised and all operatives need to store items in their designated place." />
                </ul>
            )
        },
        gro_flo_acc_egr: {
            name: "Access and Egress",
            icon: gro_flo_acc_egr,
            text: (
                <ul>
                    <ListItem text="There must be safe walking routes for workers to/ from/ and within the site." />
                    <ListItem text="There must be safe access using ladders" />
                    <ListItem text="Access to be kept clear from obstruction, materials, and equipment" />
                    <ListItem text="Access should be kept clean and tidy" />
                </ul>
            )
        },
        gro_flo_wor_rou: {
            name: "Worker on Foot Route",
            icon: gro_flo_wor_rou,
            text: (
                <ul>
                    <ListItem text="Workers will be segregated from construction plant" />
                    <ListItem text="If they are in close proximity, barriers will be provided" />
                    <ListItem text="Dedicated and clearly marked routes will be provided" />
                </ul>
            )
        },
        gro_flo_gro_con: {
            name: "Firm Ground",
            icon: gro_flo_fir_gro,
            text: (
                <ul>
                    <ListItem text="This must be assessed by a person with the proper mix of training, knowledge and experience. If the conditions are beyond the competence of the person, then expert advice must be sought." />
                    <ListItem text="The ground on which any plant, scaffold, or other equipment is to be  used  must  be  assessed  to  ensure  it  is  capable  of  bearing  the required load." />
                    <ListItem text="Preparation work on the ground may be required before the task can commence.  If  this  is  the  case,  then  this  work  must  be  completed prior to the task, and the ground conditions re-assessed." />
                    <ListItem text="Ground must be level." />
                    <ListItem text="Loads  cannot  be  placed  closer  to  excavations  edges  than  the excavation  is  deep  in  good  ground/weather  conditions.  In  poor ground/weather conditions this distance needs to be increased." />
                </ul>
            )
        },
        gro_flo_tre: {
            name: "Trestle Platform",
            icon: gro_flo_tre,
            text: (
                <ul>
                    <ListItem text="Should only be used for light duty work (painting, rendering etc)" />
                    <ListItem text="Trestles must not span open holes or be used close to leading edges." />
                    <ListItem text="They must be erected by competent persons, and be checked for suitability before use. There should be a system of regular inspections during use, taking account of how it is being used and likelihood of deterioration." />
                    <ListItem text="The platform must be of sufficient size for the work (min 450mm wide), be level and fully boarded. Boards must be a minimum of 225mm wide and be non-slip. Each board must be fully supported, including both ends, with no overhangs." />
                    <ListItem text="Safe access (via a tied ladder) should be used." />
                    <ListItem text="Fall prevention needs to be used when the scope or duration of the task presents a risk of a fall occurring. Fall prevention includes toe boards and handrails. This will always be the case above 2m, but this does not mean lower height fall prevention measures are excluded." />

                    <Li>
                        <Typography variant="title">
                            They must be free from defects and suitable for
                            their purpose.
                        </Typography>
                        <ol>
                            <ListItem text="Wear and damage to hinges, pins, holes and feet" />
                            <ListItem text="Welds and crimps for cracks, distortion, separation or loose components" />
                            <ListItem text="Twisting of the frame (all feet firmly on level ground)" />
                            <ListItem text="	Boards for wear, cracks or damage" />
                        </ol>
                    </Li>
                    <ListItem text="Store trestles in an upright position and secure against falling. Store boards supported off the ground, away from risk of falling objects. Do not store other materials on top of the boards." />
                    <ListItem text="Manufacturer approved locating pins must be used and inserted correctly" />
                    <ListItem text="The legs must be on firm foundations and not likely to slip or shift." />
                    <ListItem text="The platform must not be overloaded, kept free of trip hazards and kept tidy." />
                </ul>
            )
        },
        gro_flo_sca: {
            name: "Scaffold",
            icon: gro_flo_sca,
            text: (
                <ul>
                    <ListItem text="Where possible scaffolds should be used as working platforms when working at height." />
                    <ListItem text="These can only be erected, modified or dismantled by CSCS Basic/ Advanced scaffolding cardholders. " />
                    <ListItem text="You should have a formal handover procedure that both the erector and the user sign-off on suitability of the scaffold. The scaffold must be certified as safe to use." />
                    <ListItem text="Scaffolding must be adequately tied, braced and not overloaded." />
                    <ListItem text="Loading bays must be marked with the safe working load." />
                    <ListItem text="All platforms must be fully boarded, have toe-boards, mid-rails and top guardrails." />
                    <Li>
                        <Typography variant="title">
                            Where a scaffold exceeds 2m in height the scaffold
                            should be inspected weekly by a competent person and
                            should have a weekly GA3 report completed and
                            available on site. The scaffold will have to be
                            inspected by a competent person (who will produce a
                            written inspection report GA3 to be available on
                            site)
                        </Typography>
                        <ol>
                            <ListItem text="At least every 7 days (or after a period without use, before use re-commences)" />
                            <ListItem text="Exposure to bad weather, or" />
                            <ListItem text="Alteration, or" />
                            <ListItem text="Damage, including impact of traffic or site equipment with the scaffold." />
                        </ol>
                    </Li>
                    <ListItem text="If you discover a serious defect you should stop using the scaffold and report it to site management." />
                    <Li>
                        <Typography variant="title">should</Typography>
                        <ol>
                            <ListItem text="know and understand the conditions of use of the scaffold, including the loading capacity" />
                            <ListItem text="NOT overload the scaffold either locally or generally" />
                            <ListItem text="NOT interfere with or misuse the scaffold" />
                            <ListItem text="Promptly report defects in the scaffold to site management" />
                            <ListItem text="NOT leave the scaffold in a hazardous condition for current or subsequent users" />
                        </ol>
                    </Li>
                    <ListItem text="Any modifications (adding to or removing scaffold parts) must be undertaken by CSCS Basic/ Advanced scaffolding cardholders. Guard-rails and toe boards in a single bay may be temporarily removed by persons who have been appropriately instructed. Those persons must remain in attendance at the location of the removed guard-rail or toe-board until it has been replaced." />
                    <ListItem text="The scaffold must have designated access points. Users are not permitted to climb the scaffold structure and must use ladders. Ladders must be secured to the scaffold." />
                    <ListItem text="Materials of equipment must never be thrown or dropped from scaffolding." />
                    <ListItem text="Scaffold platforms must be kept clean and clear of materials with a clear passageway of 430mm for employees to pass." />
                    <ListItem text="Keep the scaffold working platform free from obstacles (e.g. trailing leads or loose materials)" />
                    <ListItem text="Operators can only access the scaffold after each wheel has been locked. The scaffold cannot be moved with operatives or materials on board. You should NOT use mechanical means to push the scaffold." />
                </ul>
            )
        },
        gro_flo_reb: {
            name: "Rebar",
            icon: gro_flo_reb,
            text: (
                <ul>
                    <ListItem text="Exposed rebar, particularly on access routes or in work areas, must be removed fully by cutting, bent away, or capped with plastic mushroom caps to prevent puncture injuries and trips." />
                </ul>
            )
        },
        gro_flo_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: gro_flo_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
